import { render, staticRenderFns } from "./card-recap-flight-and-stay.vue?vue&type=template&id=59d694be"
import script from "./card-recap-flight-and-stay.vue?vue&type=script&lang=js"
export * from "./card-recap-flight-and-stay.vue?vue&type=script&lang=js"
import style0 from "./card-recap-flight-and-stay.vue?vue&type=style&index=0&id=59d694be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports